import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider, useMediaQuery, useTheme } from '@mui/material'
import React from 'react'

const styles = {
    dialog: {
        "& .MuiBackdrop-root": {
            backgroundColor: "rgb(0,0,0,0.3)",
        },
    },
    title: { backgroundColor: "grey", color: "white" },
    content: { textAlign: "center" }
}
const PopUp = ({ open, setClose, msg, title = 'Atencion', titleDisabled = false, buttonDisabled = false, maxWidth = "sm" }) => {
    const theme = useTheme()
    const mobile = useMediaQuery(theme.breakpoints.down("md"))
    const handleClose = () => {
        setClose(false)
    }

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            maxWidth={mobile ? "xl" : maxWidth}
            fullWidth
            sx={styles.dialog}
        >
            {!titleDisabled && <DialogTitle sx={styles.title}>{title}</DialogTitle>}
            <Divider />
            <DialogContent sx={styles.content}>
                {msg}
            </DialogContent>
            {!buttonDisabled && <DialogActions>
                <Button autoFocus color='success' variant='text' onClick={() => handleClose()}>Aceptar</Button>
            </DialogActions>}
        </Dialog>
    )
}

export default PopUp